/*
 * modules.js
 * import the modules that you want to be able to use as value of the data-module attribute
 * then add them to the default export.
 */

import ContentEnhancements from './modules/content-enhancements.js'; // use data-module="ContentEnhancements"
import SearchAwesomplete from './modules/search-awesomplete.js'; // use data-module="SearchAwesomplete"
import SetListIcon from './modules/set-list-icon.js'; // use data-module="SetListIcon"

const modules = {
    ContentEnhancements,
    SearchAwesomplete,
    SetListIcon,
};

// this empty array is filled in the build process
const modulesInFile = [];

export function getMore(module) {
    const found = modulesInFile.find((occ) => occ?.modulenames?.includes(module));
    return found?.file ?? '';
}

export default modules;

import FormValidation from './modules/cz-forms/js/form-validation.js';
modules['FormValidation'] = FormValidation;

import CzCombobox from './modules/cz-forms/js/@webcomponent/cz-combobox.js';
modules['CzCombobox'] = CzCombobox;

import ClickAction from './modules/cz-action/js/click-action.js';
modules['ClickAction'] = ClickAction;

import Categories from './modules/cz-category-tree/js/categories.js';
modules['Categories'] = Categories;

import Datalayer from './modules/cz-datalayer/js/datalayer.js';
modules['Datalayer'] = Datalayer;

import ClassNames from './modules/cz-navigation/js/classNames.js';
modules['ClassNames'] = ClassNames;

import DomElements from './modules/cz-navigation/js/domElements.js';
modules['DomElements'] = DomElements;

import HandleNavContainer from './modules/cz-navigation/js/handleNavContainer.js';
modules['HandleNavContainer'] = HandleNavContainer;

import HandleNavDomain from './modules/cz-navigation/js/handleNavDomain.js';
modules['HandleNavDomain'] = HandleNavDomain;

import HandleOverlay from './modules/cz-navigation/js/handleOverlay.js';
modules['HandleOverlay'] = HandleOverlay;

import HandleSearch from './modules/cz-navigation/js/handleSearch.js';
modules['HandleSearch'] = HandleSearch;

import HandleSubmenus from './modules/cz-navigation/js/handleSubmenus.js';
modules['HandleSubmenus'] = HandleSubmenus;

import HandleViewportHeights from './modules/cz-navigation/js/handleViewportHeights.js';
modules['HandleViewportHeights'] = HandleViewportHeights;

import Navigation from './modules/cz-navigation/js/navigation.js';
modules['Navigation'] = Navigation;

import Shared from './modules/cz-navigation/js/shared.js';
modules['Shared'] = Shared;

import PopupOverlay from './modules/cz-popup-overlay/js/popup-overlay.js';
modules['PopupOverlay'] = PopupOverlay;

import Revealer from './modules/cz-revealer/js/revealer.js';
modules['Revealer'] = Revealer;

import ScrollToTop from './modules/cz-scroll-to-top/js/scroll-to-top.js';
modules['ScrollToTop'] = ScrollToTop;

import Services from './modules/cz-service/js/services.js';
modules['Services'] = Services;

import SideOverlay from './modules/cz-side-overlay/js/side-overlay.js';
modules['SideOverlay'] = SideOverlay;

import WhatsThat from './modules/cz-whatsthat/js/whats-that.js';
modules['WhatsThat'] = WhatsThat;

import SuperCents from './modules/cz-amount/js/super-cents.js';
modules['SuperCents'] = SuperCents;

import AlertBar from './modules/cz-alert-bar/js/alert-bar.js';
modules['AlertBar'] = AlertBar;

import ClustergridFilter from './modules/cz-cluster-grid/js/clustergrid-filter.js';
modules['ClustergridFilter'] = ClustergridFilter;

import CollectiveChoice from './modules/cz-collective/js/collective-choice.js';
modules['CollectiveChoice'] = CollectiveChoice;

import CollectiveSearch from './modules/cz-collective/js/collective-search.js';
modules['CollectiveSearch'] = CollectiveSearch;

import SearchSuggestions from './modules/cz-collective/js/search-suggestions.js';
modules['SearchSuggestions'] = SearchSuggestions;

import Feedback from './modules/cz-feedback/js/feedback.js';
modules['Feedback'] = Feedback;

import SearchFilter from './modules/cz-search/js/search-filter.js';
modules['SearchFilter'] = SearchFilter;

import SearchForm from './modules/cz-search/js/search-form.js';
modules['SearchForm'] = SearchForm;

import ToggleButtonListener from './modules/cz-toggle-button/js/toggle-button-listener.js';
modules['ToggleButtonListener'] = ToggleButtonListener;

import ToggleButton from './modules/cz-toggle-button/js/toggle-button.js';
modules['ToggleButton'] = ToggleButton;

import Tooltip from './modules/cz-tooltip/js/tooltip.js';
modules['Tooltip'] = Tooltip;

import FileUpload from './modules/cz-upload-file/js/file-upload.js';
modules['FileUpload'] = FileUpload;

import ComboboxAutocomplete from './modules/cz-vergoeding/js/comboboxAutocomplete.js';
modules['ComboboxAutocomplete'] = ComboboxAutocomplete;

import CompareInsuranceTable from './modules/cz-vergoeding/js/compare-insurance-table.js';
modules['CompareInsuranceTable'] = CompareInsuranceTable;

import SearchCompensation from './modules/cz-vergoeding/js/search-compensation.js';
modules['SearchCompensation'] = SearchCompensation;

import CzAvtableloader from './modules/cz-vergoeding/js/@webcomponent/cz-avtableloader.js';
modules['CzAvtableloader'] = CzAvtableloader;

import CzMfaloader from './modules/cz-vergoeding/js/@webcomponent/cz-mfaloader.js';
modules['CzMfaloader'] = CzMfaloader;

import CzVergelijkerloader from './modules/cz-vergoeding/js/@webcomponent/cz-vergelijkerloader.js';
modules['CzVergelijkerloader'] = CzVergelijkerloader;

import Questionnaire from './modules/cz-questionnaire/js/questionnaire.js';
modules['Questionnaire'] = Questionnaire;
